const BASE_PATH = 'packages.personalized_content_package';

const EVENT_TYPES = {
    BAD_RESPONSE: (status) => `bad_response${status ? `.${status}` : ''}`,
    EMPTY_RESPONSE: 'empty_response',
    ERROR: 'error',
    RESPONSE_TIME: 'response_time',
    TIMEOUT: 'timeout',
    CUSTOM: (text) => text.toString(),
};

module.exports = {
    BASE_PATH,
    EVENT_TYPES,
};
